import reducer from './reducer';
import * as uiAppBarActions from './actions';
import LoginUserDomain from 'domain/loginUser';

export interface AppBarType {
  photoPath: string;
  collapsedSidebar: boolean;
  loginUser: LoginUserDomain | null
}

export {
  uiAppBarActions,
};

export default reducer;
